import { render, staticRenderFns } from "./cabinetManage.vue?vue&type=template&id=1590f6a6&scoped=true&"
import script from "./cabinetManage.vue?vue&type=script&lang=js&"
export * from "./cabinetManage.vue?vue&type=script&lang=js&"
import style0 from "./cabinetManage.vue?vue&type=style&index=0&id=1590f6a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590f6a6",
  null
  
)

export default component.exports